const SigmaSquadTeam = () => {
    return (
        <div className='SSTeam'>
            <h2>Club Heads</h2>
            <div className="sep1"></div>
            <div className="leads">
                <div className="heads">
                    <p>
                        Deep Ganguly
                    </p>
                </div>
                <div className="heads">
                    <p>
                        Ishaan Kulkarni
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SigmaSquadTeam